import { create } from "zustand";

interface ClubsFiltersOpenState {
  locationOpened: boolean;
  formatOpened: boolean;
  themeOpened: boolean;
  setFilterLocationOpened: () => void;
  setFilterFormatOpened: () => void;
  setFilterThemeOpened: () => void;
  setFiltersClosed: () => void;
}

interface ClubsFiltersState {
  location: {
    address: string;
    zipCode: string;
    city: string;
    latitude: number;
    longitude: number;
  };
  format: string;
  theme: string;
  setLocation: (location: {
    address: string;
    zipCode: string;
    city: string;
    latitude: number;
    longitude: number;
  }) => void;
  clearLocation: () => void;
  setFormat: (format: string) => void;
  setTheme: (theme: string) => void;
  removeTheme: () => void;
}

interface ClubsFiltersThemeShowState {
  themeShow: string;
  setThemeShow: (themeShow: string) => void;
  removeThemeShow: () => void;
}

interface ClubsFiltersAdressesState {
  adresses: any[];
  setAdresses: (adresses: any[]) => void;
}

// Store pour les filtres ouverts
export const useClubsFiltersOpenedStore = create<ClubsFiltersOpenState>(
  (set) => ({
    locationOpened: false,
    formatOpened: false,
    themeOpened: false,
    setFilterLocationOpened: () =>
      set({ locationOpened: true, formatOpened: false, themeOpened: false }),
    setFilterFormatOpened: () =>
      set({ formatOpened: true, locationOpened: false, themeOpened: false }),
    setFilterThemeOpened: () =>
      set({ themeOpened: true, locationOpened: false, formatOpened: false }),
    setFiltersClosed: () =>
      set({ locationOpened: false, formatOpened: false, themeOpened: false }),
  }),
);

// Store pour les filtres envoyés à l'API
export const useClubsFiltersStore = create<ClubsFiltersState>((set) => ({
  location: {
    address: "",
    zipCode: "",
    city: "",
    latitude: 0,
    longitude: 0,
  },
  format: "",
  theme: "",
  setLocation: (location: {
    address: string;
    zipCode: string;
    city: string;
    latitude: number;
    longitude: number;
  }) => set({ location }),
  clearLocation: () =>
    set({
      location: {
        address: "",
        zipCode: "",
        city: "",
        latitude: 0,
        longitude: 0,
      },
    }),
  setFormat: (format: string) => set({ format }),
  setTheme: (theme: string) => set({ theme }),
  removeTheme: () => set({ theme: "" }),
}));

// Store pour le thème affiché dans le filtre Theme
export const useClubsFiltersThemeShowStore = create<ClubsFiltersThemeShowState>(
  (set) => ({
    themeShow: "",
    setThemeShow: (themeShow: string) => set({ themeShow }),
    removeThemeShow: () => set({ themeShow: "" }),
  }),
);

// Store pour les adresses
export const useClubsFiltersAdressesStore = create<ClubsFiltersAdressesState>(
  (set) => ({
    adresses: [],
    setAdresses: (adresses: any[]) => set({ adresses }),
  }),
);
